import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  coverageAreasText: {
    display: 'inline-block',
    marginRight: '8px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  showMoreOrLessText: {
    display: 'inline-block',
    fontSize: '14px',
    fontWeight: 400,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  coverageAreasHeader: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '32px',
    letterSpacing: '0.15px',
    '@media (max-width: 599px)': {
      fontSize: '20px',
      lineHeight: '28px',
    },
  },
  coverageAreasMargins: {
    margin: '12px 0px 8px 0px',
    lineHeight: '20px',
    letterSpacing: '0px',
  },
});
